document.addEventListener('DOMContentLoaded', () => {
  const $navigation = document.querySelector('.js-navigation');
  if ($navigation) {
    const $menuItems = $navigation.querySelectorAll('.js-menu-item');
    let navigationPosY = 0;

    const stickyNavigation = () => {
      const scrollY = window.pageYOffset;

      if (scrollY >= navigationPosY) $navigation.classList.add('is-sticky');
      else $navigation.classList.remove('is-sticky');
    };

    const checkActiveMenuitem = () => {
      $menuItems.forEach(($item) => $item.classList.remove('is-active'));

      $menuItems.forEach(($menuItem) => {
        const id = $menuItem.querySelector('a').getAttribute('href');
        const $section = document.querySelector(id);
        const posTop = $section.getBoundingClientRect().top;
        if (posTop < 30) {
          $menuItems.forEach(($item) => $item.classList.remove('is-active'));
          $menuItem.classList.add('is-active');
        }
      });
    };

    const getNavigationPos = () => {
      const isSticky = $navigation.classList.contains('is-sticky');
      if (isSticky) $navigation.classList.remove('is-sticky');
      navigationPosY = $navigation.offsetTop;
      if (isSticky) $navigation.classList.add('is-sticky');
    };

    const setNavigationPosition = () => {
      const delta = document.querySelector('#home').offsetHeight - window.innerHeight - $navigation.offsetHeight;
      if (delta > 0) {
        $navigation.style.bottom = `-${delta}px`;
      } else {
        $navigation.removeAttribute('style');
      }
    };

    const recalculateNavigation = () => {
      getNavigationPos();
      setNavigationPosition();
    };

    const windowScrolled = (event) => {
      if (!window.requestAnimationFrame) return;

      window.requestAnimationFrame(recalculateNavigation);
      window.requestAnimationFrame(stickyNavigation);
      window.requestAnimationFrame(checkActiveMenuitem);
    };

    window.setTimeout(recalculateNavigation, 300);
    window.addEventListener('scroll', windowScrolled);
    window.addEventListener('resize', recalculateNavigation);
  }
});
